/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FunnelStageE5 interface.
 */
export function instanceOfFunnelStageE5(value) {
    if (!('conversionRate' in value) || value['conversionRate'] === undefined)
        return false;
    if (!('paidUsers' in value) || value['paidUsers'] === undefined)
        return false;
    return true;
}
export function FunnelStageE5FromJSON(json) {
    return FunnelStageE5FromJSONTyped(json, false);
}
export function FunnelStageE5FromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'conversionRate': json['conversionRate'],
        'measurable': json['measurable'] == null ? undefined : json['measurable'],
        'paidUsers': json['paidUsers'],
    };
}
export function FunnelStageE5ToJSON(json) {
    return FunnelStageE5ToJSONTyped(json, false);
}
export function FunnelStageE5ToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'conversionRate': value['conversionRate'],
        'measurable': value['measurable'],
        'paidUsers': value['paidUsers'],
    };
}
